import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  reportsPending: [],
};

const slice = createSlice({
  name: 'reportsPending',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getReportsSuccess(state, action) {
      state.isLoading = false;
      state.reportsPending = action.payload;
    },
  },
});
export default slice.reducer;

export function getPendingAdminReports() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('admin/get/pending/reports');
      dispatch(slice.actions.getReportsSuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
